import { useContext } from 'react';
import { UserRoleContext } from './UserRoleProvider';
export var useUserRole = function () {
    var userRole = useContext(UserRoleContext).userRole;
    return userRole;
};
